"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayStatsGrowthToJSON = exports.GiveawayStatsGrowthFromJSONTyped = exports.GiveawayStatsGrowthFromJSON = exports.instanceOfGiveawayStatsGrowth = void 0;
/**
 * Check if a given object implements the GiveawayStatsGrowth interface.
 */
function instanceOfGiveawayStatsGrowth(value) {
    var isInstance = true;
    isInstance = isInstance && "twitch" in value;
    isInstance = isInstance && "youtube" in value;
    isInstance = isInstance && "tiktok" in value;
    return isInstance;
}
exports.instanceOfGiveawayStatsGrowth = instanceOfGiveawayStatsGrowth;
function GiveawayStatsGrowthFromJSON(json) {
    return GiveawayStatsGrowthFromJSONTyped(json, false);
}
exports.GiveawayStatsGrowthFromJSON = GiveawayStatsGrowthFromJSON;
function GiveawayStatsGrowthFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'twitch': json['twitch'],
        'youtube': json['youtube'],
        'tiktok': json['tiktok'],
    };
}
exports.GiveawayStatsGrowthFromJSONTyped = GiveawayStatsGrowthFromJSONTyped;
function GiveawayStatsGrowthToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'twitch': value.twitch,
        'youtube': value.youtube,
        'tiktok': value.tiktok,
    };
}
exports.GiveawayStatsGrowthToJSON = GiveawayStatsGrowthToJSON;
